import { Component, OnInit } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';

@Component({
  selector: 'app-phone-directory',
  templateUrl: './phone-directory.component.html',
  styleUrls: ['./phone-directory.component.scss']
})
export class PhoneDirectoryComponent implements OnInit {

  constructor(
    private _coreSidebarService: CoreSidebarService,
  ) { }

  ngOnInit(): void {
  }
  toggleSidebar(name): void {
    console.log("name", name)
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }
}
